import { render, staticRenderFns } from "./InvestorStatisticsPage.vue?vue&type=template&id=1986df2d&"
import script from "./InvestorStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./InvestorStatisticsPage.vue?vue&type=script&lang=js&"
import style0 from "./InvestorStatisticsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VDatePicker,VMenu,VTextField})
